'use strict';
export function scrollToAnchor(selector, speed) {
  selector = selector || '#';
  speed = speed || 500;

  var pos = $(selector).offset().top;
  $('html, body').animate(
      {
        scrollTop: pos,
      },
      speed
  );
}
